import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { getIconStyles as d } from "../styles.js";
const r = (e) => /* @__PURE__ */ C(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: d(e),
    children: [
      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_1605_35446)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.3935 2.06101C13.3025 2.02335 13.2049 2.00398 13.1064 2.00403H2.47705C2.27814 2.00403 2.08737 2.08305 1.94672 2.2237C1.80607 2.36435 1.72705 2.55512 1.72705 2.75403V22.254C1.72705 22.4529 1.80607 22.6437 1.94672 22.7844C2.08737 22.925 2.27814 23.004 2.47705 23.004H3.97705C4.39126 23.004 4.72705 23.3398 4.72705 23.754C4.72705 24.1682 4.39126 24.504 3.97705 24.504H2.47705C1.88032 24.504 1.30802 24.267 0.88606 23.845C0.464103 23.4231 0.227051 22.8508 0.227051 22.254V2.75403C0.227051 2.15729 0.464104 1.58499 0.88606 1.16304C1.30802 0.741081 1.88031 0.504028 2.47705 0.504028L13.1057 0.504028C13.4011 0.503939 13.694 0.562023 13.967 0.674966C14.24 0.787953 14.4882 0.953628 14.6972 1.16253L20.5684 7.0337C20.7773 7.24273 20.9431 7.49104 21.0561 7.76412C21.1691 8.03708 21.2271 8.32962 21.2271 8.62503V13.254C21.2271 13.6682 20.8913 14.004 20.4771 14.004C20.0628 14.004 19.7271 13.6682 19.7271 13.254V8.62503C19.7271 8.52652 19.7077 8.42863 19.6701 8.3376C19.6324 8.24665 19.5773 8.164 19.5077 8.09436L13.6369 2.22353C13.5672 2.15389 13.4845 2.09867 13.3935 2.06101Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.9771 0.504028C13.3913 0.504028 13.7271 0.839815 13.7271 1.25403V7.25403C13.7271 7.45294 13.8061 7.64371 13.9467 7.78436C14.0874 7.92501 14.2781 8.00403 14.4771 8.00403H20.4771C20.8913 8.00403 21.2271 8.33981 21.2271 8.75403C21.2271 9.16824 20.8913 9.50403 20.4771 9.50403H14.4771C13.8803 9.50403 13.308 9.26698 12.8861 8.84502C12.4641 8.42306 12.2271 7.85077 12.2271 7.25403V1.25403C12.2271 0.839815 12.5628 0.504028 12.9771 0.504028Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.69851 15.5577C7.0831 15.4038 7.51957 15.5909 7.67341 15.9755L10.6734 23.4755C10.8272 23.8601 10.6402 24.2966 10.2556 24.4504C9.87101 24.6042 9.43453 24.4172 9.28069 24.0326L6.28069 16.5326C6.12686 16.148 6.31392 15.7115 6.69851 15.5577Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.2556 15.5577C10.6402 15.7115 10.8272 16.148 10.6734 16.5326L7.67341 24.0326C7.51957 24.4172 7.0831 24.6042 6.69851 24.4504C6.31392 24.2966 6.12686 23.8601 6.28069 23.4755L9.28069 15.9755C9.43453 15.5909 9.87101 15.4038 10.2556 15.5577Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.4771 15.504C20.8913 15.504 21.2271 15.8398 21.2271 16.254V22.254C21.2271 22.4529 21.3061 22.6437 21.4467 22.7844C21.5874 22.925 21.7781 23.004 21.9771 23.004H23.4771C23.8913 23.004 24.2271 23.3398 24.2271 23.754C24.2271 24.1682 23.8913 24.504 23.4771 24.504H21.9771C21.3803 24.504 20.808 24.267 20.3861 23.845C19.9641 23.4231 19.7271 22.8508 19.7271 22.254V16.254C19.7271 15.8398 20.0628 15.504 20.4771 15.504Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.7769 15.5312C13.1017 15.4413 13.4467 15.5791 13.6202 15.8682L15.2271 18.5463L16.8339 15.8682C17.0074 15.5791 17.3524 15.4413 17.6772 15.5312C18.0021 15.6212 18.2271 15.9169 18.2271 16.254V23.754C18.2271 24.1682 17.8913 24.504 17.4771 24.504C17.0628 24.504 16.7271 24.1682 16.7271 23.754V18.9618L15.8702 20.3899C15.7346 20.6158 15.4905 20.754 15.2271 20.754C14.9636 20.754 14.7195 20.6158 14.5839 20.3899L13.7271 18.9618V23.754C13.7271 24.1682 13.3913 24.504 12.9771 24.504C12.5628 24.504 12.2271 24.1682 12.2271 23.754V16.254C12.2271 15.9169 12.452 15.6212 12.7769 15.5312Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_1605_35446", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.226074 0.5)"
        }
      ) }) })
    ]
  }
);
export {
  r as XMLIcon
};
//# sourceMappingURL=XMLIcon.js.map
